(ns frontend.view.modals.folder-management-check-lists-modal.view
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [common.schema.registry :as registry]
   [frontend.state.current-session :as session]
   [ui.components.sortable-list.view :as sortable-list]
   [frontend.view.entity :as f-entity]
   [frontend.view.modals.folder-management-check-lists-modal.event :as event]
   [frontend.view.modals.folder-management-check-lists-modal.sub :as sub]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [ui.color :as c]
   [ui.components.button.view :as button]
   [ui.components.input.checkbox :as checkbox]
   [ui.components.modal.view :as modal]
   [ui.components.select.select :as select]
   [ui.editors.data-input :as data-input]
   [ui.util :as uu]))

(def modal-key ::modal-key)

(defn check-list-item
  [item]
  (let [selected? @(rf/subscribe [::sub/selected (:db/id item)])]
    [:li
     {:class "flex gap-3 items-center"}
     [checkbox/view
      {:value     selected?
       :on-change #(rf/dispatch [::event/set-selected (:db/id item) %])}]
     [:div
      {:class    "flex-1 cursor-pointer"
       :on-click #(rf/dispatch [::event/set-selected (:db/id item) (not selected?)])}
      (:check-list/label item)]
     [:div
      [button/square-secondary-open
       {:tooltip    (loc/tr :folder-management/edit-check-list)
        :aria-label (loc/tr :folder-management/edit-check-list)
        :on-click   #(rf/dispatch [::event/start-edit item])}
       [:i.fal.fa-edit]]]]))

(defn check-lists
  [check-lists-atom]
  (let [target-type @(rf/subscribe [::sub/target-entity-type])]
    [:div
     {:class "flex flex-col gap-4"}
     [:ul
      {:class "flex flex-col gap-2"}
      (some->> @check-lists-atom
               (remove (fn [list]
                         (not= (:check-list/target-entity-type list) target-type)))
               (map (fn [list]
                      ^{:key (str "check-list-modal-" (:db/id list))}
                      [check-list-item list])))]
     [:div
      [button/sm-primary-solid
       {:on-click (fn []
                    (let [target-entity-type @(rf/subscribe [::sub/target-entity-type])]
                      (f-entity/open-creator!
                       :entity.type/check-list
                       {:start-value {:check-list/label              ""
                                      :check-list/target-entity-type target-entity-type}})))}
       [:i.fal.fa-plus]
       [:span (loc/tr :create)]]]]))

(defn field-row
  [{:keys [field]}]
  (let [field-schema (registry/get-field-schema @session/tenant-schema field)
        in-use? (some #{field} (:tenant/fields-in-use @session/tenant))]
    [:div
     {:class "flex items-center gap-2 justify-between px-1 py-1 rounded border bg-base-light"}
     [:div
      {:class "flex items-center gap-2"}
      [:div
       {:class "cursor-grab"}
       [sortable-list/drag-handle-icon]]
      [:span
       {:class (uu/cm "" (when-not in-use?
                           "line-through"))}
       (loc/field-name field field-schema)]]


     [:span
      [button/square-secondary-open
       {:tooltip    (loc/tr :folder-management/remove-field)
        :aria-label (loc/tr :folder-management/remove-field)
        :on-click   #(rf/dispatch [::event/remove-field field])}
       [:i.fal.fa-trash-alt]]]]))

(defn sorted-fields-list
  []
  (let [local-state (r/atom nil)]
    (fn []
      (let [sorted-fields (or (:sorted-fields @local-state)
                              @(rf/subscribe [::sub/edit-list-sorted-fields]))]
        [sortable-list/view
         {:items sorted-fields
          :gap 4
          :on-reorder (fn [{:keys [source-index destination-index]}]
                        (rf/dispatch-sync [::event/on-sort-end source-index destination-index]))
          :get-key (fn [item]
                     (-> item :field str))
          :render-item (fn [{:keys [item]}]
                         [field-row item])}]))))

(defn edit-list-view
  [edit-list]
  (let [selectable-field-options @(rf/subscribe [::sub/selectable-field-options])]
    [:div
     {:class "flex flex-col gap-3"}
     [:div
      {:class "flex flex-col gap-1"}
      [:label
       {:class "mb-0 font-semibold text-sm"}
       (loc/tr :check-list/label)]
      [data-input/view
       {:data-type :data.type/text-simple
        :value     (:check-list/label edit-list)
        :on-change #(rf/dispatch [::event/check-list-name-change %])}]]
     [:div
      {:class "flex flex-col gap-1"}
      [:label
       {:class "mb-0 font-semibold text-sm"}
       (loc/tr :check-list-fields)]

      [:div
       [select/view
        {:value       {:value nil
                       :label ""}
         :placeholder (loc/tr :add-more-fields)
         :on-change   #(rf/dispatch [::event/add-field %])
         :options     selectable-field-options}]]]
     [sorted-fields-list]]))

(defn view
  [{:keys [_shown? close-modal! props _topmost?]}]
  (let [{:keys [entity]} props
        on-close! (fn []
                    (rf/dispatch [::event/clear])
                    (close-modal!))]
    (rf/dispatch [::event/init entity])
    (fn [{:keys [shown? props topmost?]}]
      (let [{:keys [entity check-lists-atom]} props
            changes? @(rf/subscribe [::sub/changes?])
            edit-changes? @(rf/subscribe [::sub/edit-changes?])
            editing-list @(rf/subscribe [::sub/edit-list])
            edit-list-original @(rf/subscribe [::sub/edit-list-original])]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         on-close!
          :backdrop      "static"
          :close-button? true}
         (if editing-list
           (loc/tr :edit-check-list [(entity/display-string edit-list-original)])
           (loc/tr :manage-check-lists-for [(entity/display-string entity)]))
         (if editing-list
           [edit-list-view editing-list]
           [check-lists check-lists-atom])
         [:<>
          [modal/left-cancel-only on-close! nil]
          [modal/right-single-button
           ::c/primary
           (if editing-list
             (not edit-changes?)
             (not changes?))
           (if editing-list
             #(rf/dispatch [::event/save-list!])
             #(rf/dispatch [::event/save! entity on-close!]))
           (loc/tr :save)
           nil]]]))))
